import { Header } from "../../components/header";
import { Drawer } from "../../components/drawer";
import { Outlet } from "react-router-dom";
import { useAppState } from "../../lib/app-state";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useSocketStore } from "../../lib/socket-state.ts";
import { authClient } from "../../lib/auth-client";

type SessionWithImpersonation = {
    session?: {
        impersonatedBy?: unknown;
    };
};

export const Layout = () => {
    const sidebarOpen = useAppState((state) => state.sidebarOpen);
    const toggleSidebar = useAppState((state) => state.toggleSidebar);
    const setSidebarOpen = useAppState((state) => state.setSidebarOpen);
    const { data: session } = authClient.useSession();
    const isImpersonating = Boolean((session as SessionWithImpersonation | null | undefined)?.session?.impersonatedBy);

    // Socket state functions
    const connect = useSocketStore(state => state.connect);
    const disconnect = useSocketStore(state => state.disconnect);

    useEffect(() => {
        connect();

        return () => {
            disconnect();
        }
    }, [connect, disconnect]);

    const [isMediumScreen, setIsMediumScreen] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const mediumScreen = window.innerWidth >= 780;
            setIsMediumScreen(mediumScreen);
            if (!mediumScreen) setSidebarOpen(false);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, [setSidebarOpen]);

    // Close sidebar when clicking backdrop on mobile
    const handleBackdropClick = () => {
        if (!isMediumScreen) {
            toggleSidebar();
        }
    };

    return (
        <div className="bg-background min-h-screen flex flex-col">
            <Header />
            <Drawer />

            {sidebarOpen && !isMediumScreen && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-[2px]"
                    style={{ zIndex: 500 }}
                    onClick={handleBackdropClick}
                />
            )}

            <motion.div
                animate={{
                    marginLeft: isMediumScreen ? (sidebarOpen ? 240 : 72) : 0,
                }}
                transition={{ duration: 0.3 }}
                className={`root__container flex-1 ${isImpersonating ? "pt-[6.25rem]" : "pt-14"}`}
            >
                <Outlet />
            </motion.div>
        </div>
    );
};
